import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {setAccommodationRedirect} from "@Form/reducers/formSlice";
import {useCookies} from "react-cookie";
import {useEffect} from "react";
import getCookie from "@Cookies/functions/getCookie";
import useSetCookie from "@Cookies/hooks/useSetCookie";

export const useAccommodationToggle = () => {
    const {accommodationRedirect} = useAppSelector((state) => state?.form)
    const dispatch = useAppDispatch()

    const {
        setCookie,
    } = useSetCookie('accommodationRedirect')

    const toggleAccommodationRedirect = () => {
        setCookie('accommodationRedirect', !accommodationRedirect)
        dispatch(setAccommodationRedirect(!accommodationRedirect))
    }

    useEffect(() => {
        if (getCookie('accommodationRedirect', false) !== null) {
            dispatch(setAccommodationRedirect(getCookie('accommodationRedirect')))
        } else {
            setCookie('accommodationRedirect', true)
            dispatch(setAccommodationRedirect(true))
        }
    }, [])

    return {
        accommodationRedirect,
        toggleAccommodationRedirect,
    }
}